import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx, jsxs } from 'react/jsx-runtime';

var Svg18CartFull = /*#__PURE__*/React.memo(function (props) {
  useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18"
  }, props), {}, {
    children: /*#__PURE__*/jsxs("g", {
      fill: props.iconColor ? props.iconColor : "#010505",
      fillRule: "evenodd",
      children: [/*#__PURE__*/jsx("ellipse", {
        cx: 8.136,
        cy: 14.877,
        rx: 1.098,
        ry: 1.123
      }), /*#__PURE__*/jsx("ellipse", {
        cx: 12.786,
        cy: 14.877,
        rx: 1.098,
        ry: 1.123
      }), /*#__PURE__*/jsx("path", {
        d: "M16.808 4.646a.95.95 0 0 0-.729-.343H5.436l-.492-1.696A.82.82 0 0 0 4.159 2H1.818A.827.827 0 0 0 1 2.836c0 .462.366.837.818.837h1.714l.482 1.684 1.59 6.542a.99.99 0 0 0 .953.756h6.598c1.21-.001 2.24-.9 2.432-2.12l1.389-4.972a.6.6 0 0 0 0-.137.94.94 0 0 0-.168-.78"
      })]
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg18CartFull$1 = Svg18CartFull;

export { Svg18CartFull$1 as default };
